<template>
  <section>
    <b-modal
      ref='addProduct'
      id='addProduct'
      header-bg-variant='info'
      header-text-variant='light'
      :title="`${productId ? 'Atualizar produto' : 'Cadastrar produto'}`"
      size='xl'
      scrollable
      @show='showModal()'
      @hidden='hideModal()'
    >
      <b-overlay
        :show='loading'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block w-100'
        style='min-height: 150px'
      >
        <Role
          :roleId='null'
          :sectorId='null'
          @update='getRoles'
        >
        </Role>

        <b-modal
          ref='bind-product-roles'
          id='bind-product-roles'
          hide-footer
          hide-header
          size='xl'
        >
          <section class='modal-font-family bind-product-roles'>
            <b-overlay
              :show='loadingRoles'
              rounded
              opacity='0.6'
              spinner-small
              spinner-variant='primary'
              class='d-inline-block w-100'
              style='min-height: 150px'
            >
              <section class='d-flex align-content-center justify-content-between header'>
                <section>
                  <p class='title'>
                    Selecione os cargos para vincular a este produto
                  </p>
                </section>

                <section>
                  <b-icon
                    @click="hideModalBindProductRoles()"
                    class='cursor-pointer'
                    font-scale='2.5'
                    icon='x'
                    color='#262626'
                  >
                  </b-icon>
                </section>
              </section>

              <section class="divider my-2 mb-3"></section>

              <section
                class="roles mb-4 "
              >
                <b-form-checkbox-group
                  v-model='rolesId'
                  v-for='(role, i) in roles'
                  :key='i'
                  class='product'
                  size='lg'
                >
                  <b-form-checkbox
                    class=''
                    :value='role._id'
                  >
                    <p class='word-break product-name mt-2 mb-3'>{{ role.name }}</p>
                  </b-form-checkbox>

                  <section class="sector-bind pt-2" v-if="role.sectorsRoles && role.sectorsRoles.length > 0">
                    <section class="d-flex align-items-center ">
                      <svg width="15" height="16" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_6346_4788)">
                          <path d="M0.5 14L13.5 1" stroke="#022245" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M9.5 1H13.5V5" stroke="#022245" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M9 9.5L13.5 14" stroke="#022245" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M9.5 14H13.5V10" stroke="#022245" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M5 5.5L0.5 1" stroke="#022245" stroke-linecap="round" stroke-linejoin="round"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_6346_4788">
                            <rect width="14" height="14" fill="white" transform="translate(0 0.5)"/>
                          </clipPath>
                        </defs>
                      </svg>
                      <p class="mb-0 ml-2 title">Setores vinculados:</p>
                    </section>
                    <ul >
                      <li
                        class="mb-0 sector-name"
                        v-for="(sectorRole, i) in role.sectorsRoles" :key="`${sectorRole._id}_${i}`"
                        v-show="sectorRole.sectors && sectorRole.sectors.length > 0"
                      >
                        Setor: {{sectorRole.sectors.map(x => x.name).join(', ')}}
                      </li>
                    </ul>
                  </section>
                </b-form-checkbox-group>
              </section>

              <section class="divider my-2 mb-3"></section>

              <section class='d-flex justify-content-between mt-4'>
                <base-button
                  class='w-25 mr-3 btn-cancel'
                  @click='hideModalBindProductRoles()'
                >
                  <span>Cancelar</span>
                </base-button>

                <base-button
                  class='w-75 btn-add'
                  @click='bindRoles()'
                >
                  <span>Finalizar</span>
                </base-button>
              </section>

              <template v-slot:overlay>
                <div class='text-center loading-spinner'>
                  <b-spinner
                    style='width: 2rem; height: 2rem'
                    variant='primary'
                    label='Large Spinner'
                  ></b-spinner>
                  <h6 class='text-primary'><strong>Buscando cargos...</strong></h6>
                </div>
              </template>
            </b-overlay>
          </section>
        </b-modal>

        <section class='modal-font-family'>
          <section v-if="newCompanyHierarchyFormat" class="mt-1  pb-3 d-flex justify-content-between align-items-center">
            <button
              class="btn-to-link-role py-2 px-3"
              @click="showModalBindProductRoles()"
            >
              <span>Vincular cargos a este produto</span>
            </button>

            <button
              @click='showModalAddRole()'
              class='btn-add py-2 px-3'
            >
              <span>Criar um novo cargo</span>
            </button>
          </section>

          <section v-if="sectors && sectors.length > 0" class="my-3 sectors">
            <p class="title">Cargos que usam esse produto</p>
            <p class="">
              <strong>IMPORTANTE:</strong>
              <span class="ml-1">desmarcar os campos abaixo faz com que o produto seja desvinculado do respectivo cargo/setor. Para vincular o produto a um cargo/setor realize a ação através da aba GRO.</span>
            </p>
            <section class="d-flex flex-wrap">
              <section
                class="mr-5 mb-4"
                v-for="(sector, i) in sectors"
                :key="`${sector._id}_${i}`"
              >
                <p class="mb-1 sector-name">Setor: {{sector.sector.name}}</p>
                <section
                  class="ml-3"
                  v-for="(role, indexSectorRole) in sector.roles"
                  :key="`${role._id}_${indexSectorRole}`"
                >
                  <section class="d-flex align-items-center">
                    <b-icon
                      class="mr-2"
                      icon="chevron-down"
                    >
                    </b-icon>
                    <p class="mb-1 role-name">Cargo: {{role.name}}</p>
                  </section>
                  <section class="d-flex">
                    <section class="ml-2 line">

                    </section>
                    <section
                      class="ml-3"
                      v-for="(product, indexRoleProductLegalConsultation) in role.products"
                      :key="`${product._id}_${indexRoleProductLegalConsultation}`"
                    >
                      <b-form-checkbox
                        v-if="product && product._id"
                        :id="product._id"
                        :name="product._id"
                        :value="product._id"
                        v-model="productsIds"
                      >
                        <span
                          class="mb-1 product-name"
                        >
                          Produto: {{product.name}}
                        </span>
                      </b-form-checkbox>
                    </section>
                  </section>
                </section>
              </section>
            </section>
          </section>

          <section class='mt-1'>
            <label class='label'>Nome do produto</label>
            <base-input-text
              v-model='name'
              placeholder='Digite o nome do produto'
              class='label-input-modal'
              type='text'
            />
          </section>

          <section class='mt-4'>
            <label class='label'>Selecione o estado físico do produto</label>
            <b-form-select
              id='selectedCompany'
              v-model='physicalState'
              :options='physicalStates'
              class='mb-3'
              style='height: 50px'
              value-field='key'
              text-field='value'
              @change="degreeOfDust = null"
            >
              <template #first>
                <b-form-select-option :value='null' disabled>Selecione o estado físico do produto
                </b-form-select-option>
              </template>
            </b-form-select>
          </section>

          <section v-if='physicalState && physicalState === 1' class='ventilationIdentified  '>
            <label class="label">Marque o grau de empoeiramento</label>
            <b-form-group class='degreeOfDust' v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                stacked :key="index"
                id="radio-group-2"
                class='d-flex'
                v-model="degreeOfDust"
                v-for="(item, index) in optionsDegreeOfDust"
              >
                <b-tooltip  :target="`degreeOfDust${item.key}`" triggers="hover" placement="top">
                  {{ item.description }}
                </b-tooltip>

                <b-form-radio :value="item.key">
                  <label :style="degreeOfDust === item.key ? 'font-weight: 700; color: var(--navy-blue)' : ''">{{item.value}}</label>&nbsp;
                  <svg :id="`degreeOfDust${item.key}`" width="17" height="17" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.95 16C10.3 16 10.596 15.879 10.838 15.637C11.08 15.395 11.2007 15.0993 11.2 14.75C11.2 14.4 11.0793 14.104 10.838 13.862C10.5967 13.62 10.3007 13.4993 9.95 13.5C9.6 13.5 9.30433 13.621 9.063 13.863C8.82167 14.105 8.70067 14.4007 8.7 14.75C8.7 15.1 8.821 15.396 9.063 15.638C9.305 15.88 9.60067 16.0007 9.95 16ZM9.05 12.15H10.9C10.9 11.6 10.9627 11.1667 11.088 10.85C11.2133 10.5333 11.5673 10.1 12.15 9.55C12.5833 9.11667 12.925 8.704 13.175 8.312C13.425 7.92 13.55 7.44933 13.55 6.9C13.55 5.96667 13.2083 5.25 12.525 4.75C11.8417 4.25 11.0333 4 10.1 4C9.15 4 8.379 4.25 7.787 4.75C7.195 5.25 6.78267 5.85 6.55 6.55L8.2 7.2C8.28333 6.9 8.471 6.575 8.763 6.225C9.055 5.875 9.50067 5.7 10.1 5.7C10.6333 5.7 11.0333 5.846 11.3 6.138C11.5667 6.43 11.7 6.75067 11.7 7.1C11.7 7.43333 11.6 7.746 11.4 8.038C11.2 8.33 10.95 8.60067 10.65 8.85C9.91667 9.5 9.46667 9.99167 9.3 10.325C9.13333 10.6583 9.05 11.2667 9.05 12.15ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6867 3.825 17.9743 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.263333 12.6833 0.000666667 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31333 4.88333 2.02567 3.825 2.925 2.925C3.825 2.025 4.88333 1.31267 6.1 0.788C7.31667 0.263333 8.61667 0.000666667 10 0C11.3833 0 12.6833 0.262667 13.9 0.788C15.1167 1.31333 16.175 2.02567 17.075 2.925C17.975 3.825 18.6877 4.88333 19.213 6.1C19.7383 7.31667 20.0007 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6867 15.1167 17.9743 16.175 17.075 17.075C16.175 17.975 15.1167 18.6877 13.9 19.213C12.6833 19.7383 11.3833 20.0007 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z" fill="#022245"/>
                  </svg>
                </b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </section>

          <section class='mt-4'>
            <label class='label'>Descrição do produto</label>
            <base-text-area
              v-model='description'
              placeholder='Descreva aqui como é utilizado este produto. Informações sobre como o trabalhador faz uso deste produto, se ele dilui/mistura/dissolve, se o produto está em forma líquida ou sólida são boas informações para que possamos te ajudar a reconhecer seus riscos.'
              type='text'
            />
          </section>

          <section>
            <a class='file-uploaded mt-3' v-if='urlFISPQ' :href='urlFISPQ' target='_blank'>
              Clique aqui para ver o arquivo anexado anteriormente
            </a>
          </section>

          <section class='mt-3'>
            <input
              type='file'
              id='files'
              @change='onChange'
              hidden
              accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            />
            <label class='file-product d-flex align-items-center' for='files'>
              <strong class='ml-3' v-if='files && files.name'>{{ files.name }}</strong>

              <svg v-if='!files.name' class='ml-3 mr-2' width='18' height='18' viewBox='0 0 10 18' fill='none'
                   xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M3.12969 6.00003V12.743C3.13748 13.2361 3.33882 13.7063 3.69026 14.0523C4.0417 14.3982 4.51507 14.5921 5.0082 14.5921C5.50134 14.5921 5.9747 14.3982 6.32615 14.0523C6.67759 13.7063 6.87893 13.2361 6.88672 12.743L6.89281 3.90472C6.89792 3.48328 6.81933 3.06502 6.66159 2.67418C6.50385 2.28334 6.2701 1.9277 5.97389 1.62787C5.67768 1.32804 5.3249 1.09 4.93601 0.927526C4.54711 0.765056 4.12983 0.681396 3.70836 0.681396C3.28689 0.681396 2.86961 0.765056 2.48071 0.927526C2.09182 1.09 1.73904 1.32804 1.44283 1.62787C1.14661 1.9277 0.912864 2.28334 0.755124 2.67418C0.597384 3.06502 0.518793 3.48328 0.523906 3.90472V12.8025C0.51532 13.3959 0.624765 13.985 0.84588 14.5356C1.067 15.0863 1.39537 15.5875 1.81191 16.0101C2.22845 16.4327 2.72484 16.7683 3.27223 16.9973C3.81962 17.2264 4.40709 17.3443 5.00047 17.3443C5.59385 17.3443 6.18132 17.2264 6.72871 16.9973C7.2761 16.7683 7.77249 16.4327 8.18903 16.0101C8.60557 15.5875 8.93394 15.0863 9.15506 14.5356C9.37617 13.985 9.48562 13.3959 9.47703 12.8025V4.48785'
                  stroke='#808080' stroke-miterlimit='10' stroke-linecap='round' />
              </svg>

              <span v-if='!files.name'>Clique aqui para anexar a FDS ou FISPQ desse produto</span>
            </label>
          </section>

          <section v-if="chemicalAgentsFispq && chemicalAgentsFispq.length > 0" class="mt-4">
            <p>
              <strong>
                Os seguintes dados foram extraídos automaticamente via IA do documento {{ files.name }}.
              </strong>
            </p>

            <section>
              <table class="table-form">
                <thead>
                <tr>
                  <th>Agente</th>
                  <th class="px-2">CAS</th>
                  <th>Composição Máx. (%)</th>
                </tr>
                </thead>

                <tbody>
                <tr class="py-1" v-for="(item, i) in chemicalAgentsFispq" :key="i">
                  <td class="pb-2">
                    <input
                      type="text"
                      disabled
                      :value="item.agentName"
                      :class="item.agentName ? '' : 'error'"
                    />
                  </td>

                  <td class="px-2 pb-2">
                    <input
                      type="text"
                      disabled
                      :value="item.casAgent"
                      :class="item.casAgent ? '' : 'error'"
                    />
                  </td>

                  <td class="pb-2">
                    <input
                      type="text"
                      disabled
                      :value="item.percentage"
                      :class="item.percentage ? '' : 'error'"
                    />
                  </td>
                </tr>
                </tbody>
              </table>
            </section>
          </section>
        </section>

        <template v-slot:overlay>
          <div class='text-center loading-spinner'>
            <b-spinner
              style='width: 3rem; height: 3rem'
              variant='primary'
              label='Large Spinner'
            ></b-spinner>
            <h5 class='text-primary'>{{textLoading}}</h5>
          </div>
        </template>
      </b-overlay>

      <template #modal-footer="{ cancel }">
        <section class='w-100 modal-font-family'>
          <section>
            <b-alert show variant='danger' :class='{ hidden: !error }'>
              {{ error }}<br />
            </b-alert>
            <b-alert show variant='warning' :class='{ hidden: !warning }'>
              {{ warning }}<br />
            </b-alert>
            <b-alert show variant="success" dismissible :class="{ hidden: !message }">
              {{ message }}
            </b-alert>
          </section>
          <section class='d-flex justify-content-between w-100'>
            <base-button
              class='w-50 mr-3 btn-cancel'
              @click='hideModalAddProduct()'
              :disabled="loading"
            >
              <span>Cancelar</span>
            </base-button>

            <b-overlay
              :show='loading'
              rounded
              opacity='0.6'
              spinner-small
              spinner-variant='primary'
              class='d-inline-block w-50'
            >
              <base-button
                class='w-100 btn-add d-flex align-items-center justify-content-center'
                @click='add()'
                :disabled="loading"
              >
                  <span class='mr-2'>
                    {{ productId ? 'Atualizar' : (productFispq ? 'Cadastrar produto' : 'Adicionar') }}
                  </span>
              </base-button>
            </b-overlay>
          </section>
        </section>
      </template>
    </b-modal>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import useVuelidate from '@vuelidate/core'
import eventBus from '@/utils/eventBus'
import { physicalProductStates } from '@/mocks/physicalProductStates'
import { optionsDegreeOfDust } from '@/mocks/optionsDegreeOfDust'
import Role from '@/components/LegalSearch/Gro/components/Role.vue'
import moment from 'moment'
import products from '@/components/LegalSearch/Gro/components/Products.vue'
import { extractChemicalAgentsFispqProduct } from '@/services/hoFacilApiChat'
import { upload } from '@/utils/upload'

export default {
  name: 'ProductAdd',
  components: { Role },
  props: {},
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      textLoading: 'Buscando produto...',
      loadingRoles: false,
      loading: false,
      roles: [],
      sectors: [],
      productsIds: [],
      productsIdsHierarchy: [],
      rolesId: [],
      files: [],
      sectorId: null,
      name: "",
      roleId: null,
      description: "",
      legalSearches: [],
      physicalState: null,
      degreeOfDust: null,
      selectedRole: null,
      urlFISPQ: null,
      productId: null,
      chemicalAgentsFispq: [],
      agentsLackProduct: [],
      physicalStates: [],
      optionsDegreeOfDust: [],
      errors: {
        roleId: 'Selecione o cargo do trabalhador que usa esse produto',
        name: 'Digite o nome do produto',
        physicalState: 'Selecione o estado físico do produto',
      },
      dateNewFormatCompanyHierarchy: new Date(),
      newCompanyHierarchyFormat: false,
      productFispq: null,
      handleBeforeUnload: null,
      extractionAttempts: [],
      logFispqProduct: null,
      extractionStartTime: null
    }
  },
  mounted() {
    try {
      eventBus.$on('showModalAddProduct', async (data) => {
        this.productId = null
        this.productFispq = null
        const {productId, productFispq} = data || {}
        if (productId) {
          this.productId = productId
          this.$bvModal.show('addProduct')
        } else if(productFispq) {
          this.productFispq = productFispq
          this.$bvModal.show('addProduct')
        } else {
          await this.analyzeAgents()
        }
      })

      this.handleBeforeUnload = () => {
        try {
          const { _id } = this.logFispqProduct
          if (!_id) {
            return
          }
          const sessionId = localStorage.getItem('sessionId')
          const tokenHofacil = localStorage.getItem('tokenHofacil')
          const body = JSON.stringify(
            {
              ...this.logFispqProduct,
              log: 'O usuário atualizou a página ou fechou a janela durante a extração das informações da FISPQ do produto.',
              fispqReadTimeInSeconds: Math.floor((new Date().getTime() - this.extractionStartTime.getTime()) / 1000),
              extractionAttempts: this.extractionAttempts
            })
          fetch(`${process.env.VUE_APP_BASE_URL}/fispq-logs/finish`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              sessionId,
              Authorization: tokenHofacil
            },
            body,
            keepalive: true
          })
        } catch (e) {
        }
      }
      window.addEventListener('beforeunload', this.handleBeforeUnload)
    } catch (e) {
      this.loading = false
    }
  },
  async beforeDestroy() {
    eventBus.$off('showModalAddProduct')
    await this.$store.dispatch('access/updateWarning', '')
    await this.$store.dispatch('access/updateError', '')
    await this.$store.dispatch('access/updateMessage', '')
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
    await this.updateLogFispqProduct('O usuário saiu da página durante o processo de extração das informações da FISPQ do produto!')
  },
  computed: {
    products() {
      return products
    },
    error() {
      return this.$store.getters['access/error']
    },
    summaryMeta() {
      return this.$store.getters['legalSearch/summaryMeta']
    },
    warning() {
      return this.$store.getters['access/warning']
    },
    message() {
      return this.$store.getters['access/message']
    },
    summary() {
      return this.$store.getters['legalSearch/summary']
    },
    user() {
      return this.$store.getters['user/current']
    },
    disabled() {
      return !(this.name && this.description /*&& (this.roles && this.roles.length > 0)*/ && this.physicalState && (this.physicalState === 2 || this.physicalState === 3 || this.degreeOfDust))
    },
    ...mapGetters('legalSearch', {
      selectedAgents: 'selectedAgents'
    }),
    ...mapGetters('companyLegalConsultation', {
      importedCompany: 'importedCompany'
    })
  },
  methods: {
    ...mapActions('productLegalConsultation', {
      handleCreateProductLegalConsultation: 'handleCreateProductLegalConsultation',
      handleAddAgentProductLegalConsultation: 'handleAddAgentProductLegalConsultation',
      handleGetProductLegalConsultation: 'handleGetProductLegalConsultation',
      handleUpdateProductLegalConsultation: 'handleUpdateProductLegalConsultation',
      setDisableProduct: 'setDisableProduct',
      handleGetProductLegalConsultationHierarchical: 'handleGetProductLegalConsultationHierarchical',
      handleBindRolesProductLegalConsultation: 'handleBindRolesProductLegalConsultation',
      handleUnlinkProduct: 'handleUnlinkProduct',
    }),
    ...mapActions('companyLegalConsultation', {
      handleUpdateAgentsCompanyLegalConsultation: 'handleUpdateAgentsCompanyLegalConsultation'
    }),
    ...mapActions('legalSearch', {
    }),
    ...mapActions('role', {
      handleGetByCompany: 'handleGetByCompany'
    }),
    ...mapActions('chemicalAgent', {
      handleProcessChemicalAgentsFispq: 'handleProcessChemicalAgentsFispq'
    }),
    ...mapActions('feedback', {
      handlesSendFispqExtractionErrorEmail: 'handlesSendFispqExtractionErrorEmail'
    }),
    ...mapActions('logFispqProduct', {
      handleCreateLogFispqProduct: 'handleCreate',
      handleFinishLogFispqProduct: 'handleFinish'
    }),
    async showModalBindProductRoles() {
      this.$bvModal.show('bind-product-roles')
      this.loadingRoles = true
      await this.getRoles()
      this.loadingRoles = false
    },

    hideModalBindProductRoles(){
      this.$bvModal.hide('bind-product-roles')
    },

    async bindRoles(){
      if(!this.productId){
        this.hideModalBindProductRoles()
        return
      }
      this.loading = true
      this.hideModalBindProductRoles()
      await this.handleBindRolesProductLegalConsultation(
        {
          rolesId: this.rolesId && this.rolesId.length > 0 ? this.rolesId : [],
          _id: this.productId
        }
      )
      await this.getHierarchical()
      await this.load()
      this.loading = false
    },

    async hideModal() {
      await this.updateLogFispqProduct('O usuário encerrou o modal durante o processo de extração das informações da FISPQ do produto!')
    },

    async showModal() {
      try {
        this.loading = true
        this.files = []
        this.sectors = []
        this.rolesId = []
        this.urlFISPQ = null
        this.name = ""
        this.roleId = null
        this.description = ""
        this.physicalState = null
        this.selectedRole = null
        this.degreeOfDust = null
        this.chemicalAgentsFispq = []
        this.legalSearches = []
        Object.assign(this.physicalStates, physicalProductStates)
        Object.assign(this.optionsDegreeOfDust, optionsDegreeOfDust)
        this.textLoading = 'Buscando produto...'
        await this.$store.dispatch('access/updateError', '')
        await this.$store.dispatch('access/updateWarning', '')
        await this.$store.dispatch('access/updateMessage', '')
        if (this.productId) {
          const { data } = await this.handleGetProductLegalConsultation(this.productId)
          const { urlFISPQ, name, description, physicalState, role, degreeOfDust, roleProductLegalConsultation, legalSearches } = data.product
          this.name = name
          this.description = description
          this.urlFISPQ = urlFISPQ
          this.physicalState = physicalState
          this.degreeOfDust = degreeOfDust
          this.roleId = role
          this.rolesId = roleProductLegalConsultation && roleProductLegalConsultation.length > 0 ? roleProductLegalConsultation.map(x => x.roleId) : []
          this.legalSearches = legalSearches
          await this.getHierarchical()
        } else if (this.productFispq){
          const { name, description, physicalState, file, chemicalAgentsFispq } = this.productFispq || {}
          this.name = name || null
          this.description = description || ''
          this.physicalState = physicalState || null
          this.files = file || []
          this.chemicalAgentsFispq = chemicalAgentsFispq || []
        }
        this.dateNewFormatCompanyHierarchy = new Date(process.env.VUE_APP_DATE_NEW_FORMAT_COMPANY_HIERARCHY)
        this.newCompanyHierarchyFormat = moment(new Date(this.importedCompany.createdAt)).isSameOrAfter(moment(this.dateNewFormatCompanyHierarchy))
        this.loading = false
      } catch (e) {

      }
    },

    async getHierarchical() {
      const { data } = await this.handleGetProductLegalConsultationHierarchical({id: this.productId, companyId: this.importedCompany._id})
      const {sectors} = data
      this.sectors = sectors
      this.productsIds = []
      this.productsIdsHierarchy = []
      this.sectors.forEach((sector) => {
        sector.roles.forEach((role) => {
          role.products.forEach((product) => {
            this.productsIds.push(product._id)
            this.productsIdsHierarchy.push(product._id)
          })
        })
      })
    },

    async showModalAddRole() {
      try {
        setTimeout(() => {
          this.$bvModal.show('role')
        }, 100)
      } catch (e) {
      }
    },

    setSelectedRole(event){
      this.selectedRole = true;
    },

    async getRoles() {
      try {
        const { data: dataRoles } = await this.handleGetByCompany(this.importedCompany._id)
        const { roles } = dataRoles
        this.roles = roles

        this.rolesId = []
        if(this.productId) {
          const { data } = await this.handleGetProductLegalConsultation(this.productId)
          const { roleProductLegalConsultation } = data.product
          this.rolesId = roleProductLegalConsultation && roleProductLegalConsultation.length > 0 ? roleProductLegalConsultation.map(x => x.roleId) : []
        }
      } catch (e) {

      }
    },

    async onChange(event) {
      await this.$store.dispatch('access/updateWarning', '')
      await this.$store.dispatch('access/updateError', '')
      await this.$store.dispatch('access/updateMessage', '')
      const files = Array.from(event.target.files)
      const [file] = files
      const { name, type } = file || {}
      const allowedTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ]

      if (!allowedTypes.includes(file.type)) {
        await this.$store.dispatch('access/updateError', 'Formato de arquivo inválido. Por favor, anexe um arquivo PDF ou Word (.doc ou .docx)!')
        return
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.files = file
        this.extractChemicalAgents(reader.result, name, type)
      };
      this.files = file
    },

    async extractChemicalAgents(fileBase64, fileName, type) {
      try {
        this.loading = true
        this.textLoading = 'Extraindo os agentes químicos da FISPQ do produto…'
        await this.$store.dispatch('access/updateWarning', '')
        await this.$store.dispatch('access/updateError', '')
        await this.$store.dispatch('access/updateMessage', '')
        const body = { fileBase64, fileName, type }
        const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))

        const maxRetries = 3
        let response = null
        let success = false
        this.chemicalAgentsFispq = []
        this.extractionAttempts = []
        this.agentsLackProduct = []
        this.logFispqProduct = null
        this.extractionStartTime = new Date()
        let filePath = null
        try {
          filePath = await upload(this.files)
        } catch (e) {
          console.log(e)
        }

        const { username, id: userId } = this.user || {}
        const { data: dataCreateLogFispqProduct } = await this.handleCreateLogFispqProduct({
          userId,
          filePath,
          fileName,
          functionality: 'Extração de agentes químicos da FISPQ do produto',
        })

        const { data } = dataCreateLogFispqProduct || {}
        this.logFispqProduct = data
        let statusResponse = 200
        try {
          for (let attempt = 1; attempt <= maxRetries; attempt++) {
            try {
              response = await extractChemicalAgentsFispqProduct(body)
              if (!response) {
                await delay(2000)
                continue
              }

              if(response && response.data && response.data.product && response.data.extractionAttempts && response.data.extractionAttempts.length > 0) {
                this.extractionAttempts.push(...response.data.extractionAttempts.map((item) => {
                  return {
                    ...item,
                    tentativa: attempt
                  }
                }))
              }

              const { data, status } = response || {}
              statusResponse = status
              if (status !== 200) {
                await delay(2000)
                continue
              }

              let product = null
              try {
                const { product: productData } = data || {}
                product = productData
              } catch {
                await delay(2000)
                continue
              }

              const { agentes: agents } = product || {}
              if (!agents || agents.length <= 0){
                await delay(2000)
                continue
              }

              const { data: dataResponse } = await this.handleProcessChemicalAgentsFispq(
                {
                  agents,
                  userId: this.user.id,
                  planId: this.user.plan && this.user.plan._id ? this.user.plan._id : null
                }
              )
              const { data: chemicalAgentsFispq } = dataResponse || {}
              this.chemicalAgentsFispq = chemicalAgentsFispq && chemicalAgentsFispq.length > 0 ? chemicalAgentsFispq : []
              this.loading = false
              success = true
              await this.$store.dispatch('access/updateMessage', 'Os agentes químicos foram extraídos com sucesso da FISPQ.')
              break
            } catch (error) {
              if (attempt === maxRetries) {
                break
              }
              await delay(2000)
            }
          }
          if(success){
            await this.updateLogFispqProduct('Extração das informações da FISPQ do produto realizada com sucesso.')
            return
          }
          await this.updateLogFispqProduct('Não foi possível extrair as informações da FISPQ do produto.')
          let url = null
          try {
            url = await upload(this.files)
          } catch (e) {
            console.log(e)
          }
          const { data } = response || {}
          const bodyFispqExtractionErrorEmail = {
            username,
            url,
            functionality: 'Extração de agentes químicos da FISPQ do produto',
            returned: JSON.stringify(data)
          }
          await this.handlesSendFispqExtractionErrorEmail(bodyFispqExtractionErrorEmail)
          if(statusResponse == 200) {
            await this.$store.dispatch('access/updateWarning', `Não foram encontrados agentes com número CAS escrito/expresso dentro da FISPQ/FDS anexada.`)
            return
          }
          await this.$store.dispatch('access/updateError', 'Não foi possível extrair as informações do arquivo anexado. Verifique o arquivo e tente novamente!')
        } catch (e) {
          await this.$store.dispatch('access/updateError', 'Não foi possível extrair as informações do arquivo anexado. Verifique o arquivo e tente novamente!')
        } finally {
          this.loading = false
        }
      } catch (e) {
        await this.$store.dispatch('access/updateError', 'Não foi possível extrair as informações do arquivo anexado. Verifique o arquivo e tente novamente!')
      } finally {
        this.loading = false
      }
    },

    async updateLogFispqProduct(log) {
      try {
        const { _id } = this.logFispqProduct || {}
        if (!_id) {
          return
        }
        await this.handleFinishLogFispqProduct({
          ...this.logFispqProduct,
          log,
          fispqReadTimeInSeconds: Math.floor((new Date().getTime() - this.extractionStartTime.getTime()) / 1000),
          extractionAttempts: this.extractionAttempts
        })
        this.logFispqProduct = null
      } catch (e) {

      }
    },

    processAgentsLackProduct(chemicalAgentsFispq){
      try {
        if(this.productId){
          return chemicalAgentsFispq.filter((x) => !this.legalSearches.map(x => x.casAgent).includes(x.casAgent))
        } else {
          const selectedAgents = this.summary.filter((x) => this.selectedAgents.includes(x.legalSearchId))
          return chemicalAgentsFispq.filter((x) => !selectedAgents.map(x => x.cas).includes(x.casAgent))
        }
      } catch (e) {
        return []
      }
    },

    async add() {
      await this.$store.dispatch('access/updateError', '')
      await this.$store.dispatch('access/updateWarning', '')
      if (this.disabled){
        let message = ``;
        /*if (!this.roles || this.roles.length <= 0){
          message = `Selecione pelo menos um cargo para vincular ao produto`;
        } else*/ if (!this.name){
          message = `Preencha o nome do produto`;
        } else if (!this.physicalState){
          message = `Selecione o estado físico do produto`;
        } else if (this.physicalState === 1 && !this.degreeOfDust ){
          message = `Selecione o o grau de empoeiramento`;
        } else {
          message = `Preencha a descrição do produto`;
        }
        await this.$store.dispatch('access/updateError', message)
        return
      }
      this.loading = true
      let response = null

      if (this.productId) {
        this.textLoading = 'Atualizando produto...'
        response = await this.handleUpdateProductLegalConsultation(
          {
            name: this.name,
            description: this.description,
            file: this.files,
            urlFISPQ: this.urlFISPQ,
            physicalState: this.physicalState,
            degreeOfDust: this.degreeOfDust,
            role: this.roleId,
            id: this.productId,
            productsIds: this.productsIdsHierarchy.filter((x) => !this.productsIds.includes(x)),
            chemicalAgentsFispq: this.processAgentsLackProduct(this.chemicalAgentsFispq),
          }
        )
        this.$bvToast.toast(`Produto atualizado com sucesso.`, {
          title: 'Atenção',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 6000
        })
      } else {
        this.textLoading = 'Cadastrando produto...'
        response = await this.handleCreateProductLegalConsultation(
          {
            companyId: this.importedCompany && this.importedCompany._id ? this.importedCompany._id : null,
            name: this.name,
            description: this.description,
            role: this.roleId,
            physicalState: this.physicalState,
            degreeOfDust: this.degreeOfDust,
            legalSearchesId: this.selectedAgents,
            file: this.files,
            user: this.user.id,
            rolesId: this.rolesId && this.rolesId.length > 0 ? this.rolesId : [],
            chemicalAgentsFispq: this.processAgentsLackProduct(this.chemicalAgentsFispq),
          }
        )

        this.$bvToast.toast(`Produto cadastrado com sucesso.`, {
          title: 'Atenção',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 6000
        })
      }
      this.productFispq = null
      this.chemicalAgentsFispq = []
      this.loading = false
      this.hideModalAddProduct()
      await this.load()
      if (this.importedCompany && this.importedCompany._id) {
        const bodyUpdateAgents = {
          companyId: this.importedCompany._id,
          legalSearchesId: this.selectedAgents
        }
        await this.handleUpdateAgentsCompanyLegalConsultation(bodyUpdateAgents)
      }
      this.$emit('clear-items-remove')
    },

    hideModalAddProduct() {
      this.$bvModal.hide('addProduct')
    },

    async load() {
      await this.$store.dispatch('legalSearch/load', this.user.id)
    },

    async analyzeAgents() {
      const agentes = this.summary.filter((x) => this.selectedAgents.includes(x.legalSearchId))
      const agentesVinculadoProduto = agentes.filter((x) => x.product && x.product._id)
      const agentesSemVinculosProduto = agentes.filter((x) => !x.product)

      const agentesVinculadoProdutoAgrupadoPorProduto = agentesVinculadoProduto.reduce((group, agent) => {
        const product = agent.product._id
        group[product] = group[product] ? group[product] : []
        group[product].push(agent)
        return group
      }, {})
      const keys = Object.keys(agentesVinculadoProdutoAgrupadoPorProduto)

      if (agentesVinculadoProduto.length > 0 && agentesSemVinculosProduto.length > 0 && keys.length === 1) {
        await this.setDisableProduct(true)
        const product = agentesVinculadoProdutoAgrupadoPorProduto[keys[0]][0].product
        await this.handleAddAgentProductLegalConsultation(
          {
            user: this.user.id,
            productId: product._id,
            legalSearchesId: agentesSemVinculosProduto.map((x) => x.legalSearchId),
            companyId: this.importedCompany && this.importedCompany._id ? this.importedCompany._id : null
          }
        )

        await this.handleUpdateAgentsCompanyLegalConsultation(
          {
            companyId: this.importedCompany._id,
            legalSearchesId: agentesSemVinculosProduto.map((x) => x.legalSearchId)
          }
        )
        await this.load()
        this.$emit('clear-items-remove')
        await this.setDisableProduct(false)
      } else {
        this.$bvModal.show('addProduct')
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.bind-product-roles {
  .header {
    .title{
      font-weight: 700;
      font-size: 20px;
      color: #262626;
    }
  }
  .roles{
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(25%, auto));
    min-height: 80px
  }
  .divider{
    width: 100%;
    height: .5px;
    background: #C0C0C0;
  }
}
.sectors{
  .title{
    font-weight: 700;
    font-size: 17px;
    color: #262626;
  }
  .sector-name{
    font-weight: 600;
    font-size: 15px;
    color: #000000;
  }
  .role-name{
    font-weight: 500;
    font-size: 15px;
    color: #000000;
  }
  .line{
    border-left: 1px solid #9C9C9C;
  }
  .product-name{
    font-weight: 400;
    font-size: 15px;
    color: #000000;
  }
}

.file-uploaded {
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  color: var(--navy-blue);
  border: 1px solid var(--navy-blue);

  padding: 6px 12px;

  border-radius: 4px;

  transition: all 0.2s ease-in-out;

  text-decoration: none;

  cursor: pointer;
}

.file-product {
  border-radius: 6.25px;
  border: 1px dashed #808080;
  width: 100%;
  height: 40px;
  cursor: pointer;

  span {
    color: #808080;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
  }
}

.btn-cancel {
  background: transparent !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: var(--navy-blue);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.btn-add {
  background: var(--navy-blue) !important;
  border-radius: 6.25px !important;
  border: 1px solid var(--navy-blue) !important;

  span {
    color: #FFFFFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
  }
}

.label {
  margin-bottom: -8px !important;
  font-weight: 700 !important;
}
.btn-to-link-role{
  border-radius: 6.25px !important;
  background: #04A8F3;
  span{
    color: #FFFFFF;
    font-weight: 600;
  }
  border: none;
}
.degreeOfDust{
  border: 1px solid var(--border-input);
  border-radius: 4px;
  padding:10px;
}
.products-title {
  color: #262626;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.products-sub-title {
  color: #808080;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  margin-bottom: 0;
}

.product {
  border-radius: 10px;
  border: 1px solid var(--navy-blue);
  padding: 5px;
  margin: 12px 12px 0 0;
}

.product-name {
  color: var(--navy-blue);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}

.product-agent {
  color: #808080;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}
.sector-bind{
  border-top: 1px solid #C0C0C0;
  .title{
    font-weight: 600;
    font-size: 16px;
    color: #022245;
  }
  .sector-name{
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    margin-left: 40px;
  }
}
.obs {
  display: flex;
  align-items: center;
  justify-content: start;
  background: rgba(4, 168, 243, 0.4);
  border-radius: 6.25px;
  padding: 10px;
  span{
    font-weight: 400;
    font-size: 15px;
  }
  a{
    font-weight: 700;
    font-size: 15px;
    text-decoration: underline;
    color: #022245;
  }
}
.table-form {
  width: 100%;
  border-collapse: separate;
}

.table-form th {
  text-align: left;
  font-weight: 600;
  font-size: 18px;
  color: #222;
  padding-bottom: 4px;
}

.table-form td {
  vertical-align: top;
}

.table-form input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  font-size: 16px;
  border-radius: 8px;
  border: 1px solid #808080;
  color: #262626;
  outline: none;
}

.table-form input:focus {
  border-color: #5b9cff;
}

.table-form input.error {
  border: 1px solid #ff3b30;
}
</style>
